import React from 'react'
import EventRegistrationApprovalList from '../../features/eventManagement/EventRegistrationApprovalList'

const EventRegistrationApproval = () => {
    return (
        <EventRegistrationApprovalList />
    )
}

export default EventRegistrationApproval